import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { Page } from '~/components/ui/page';
import { Body1, Title } from '../ui/typography';

interface IdentityCheckWhatsAppMismatchScreenProps {
  whatsappNumber: string | null;
  developmentName?: string;
  goBack?: () => void;
  /**
   * When provided, the customer may continue the validation in the current
   * conversation to talk with the support, giving up on receiving the boletos
   * through WhatsApp. Only provided when they chose to talk with the support.
   */
  onContinueToSupport?: () => void;
}

export const IdentityCheckWhatsAppMismatchScreen: FC<IdentityCheckWhatsAppMismatchScreenProps> = ({
  whatsappNumber,
  developmentName,
  goBack,
  onContinueToSupport,
}) => {
  const handleWhatsApp = () => {
    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        'Olá, gostaria de receber os links dos boletos por aqui',
      )}`,
      '_blank',
    );
  };

  const baseMessage = developmentName
    ? `Os boletos do empreendimento ${developmentName} são enviados por um número separado, e para ativar você precisa iniciar a confirmação por lá.`
    : 'Os boletos do empreendimento são enviados por um número separado, e para ativar você precisa iniciar a confirmação por lá.';

  const continueToSupportMessage = onContinueToSupport
    ? 'Além de iniciar a conversa no número do empreendimento, você pode continuar para falar com o atendente.'
    : '';

  const message = baseMessage + ' ' + continueToSupportMessage;

  return (
    <Page innerWrapperSx={{ width: { xs: '100%', sm: '800px' } }}>
      <Title>Seus boletos chegam por outro número</Title>
      <Body1>{message}</Body1>
      <img style={{ marginTop: '30px' }} src="/other-number-notification.svg" />
      <Grid container spacing={2} justifyContent="center">
        {whatsappNumber && (
          <Grid item xs={12} md={6} mt={4}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<WhatsappIcon />}
              onClick={handleWhatsApp}
              sx={{ height: '50px', fontWeight: 'bold', fontSize: '1rem', textTransform: 'none' }}
            >
              Ativar meus boletos
            </Button>
            <Typography variant="caption" color="textSecondary">
              A mensagem já vai escrita. É só enviar.
            </Typography>
          </Grid>
        )}
        {onContinueToSupport && (
          <Grid item xs={12} md={6} mt={{ xs: 0, md: 4 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={onContinueToSupport}
              sx={{ height: '50px', fontWeight: 'bold', fontSize: '1rem', textTransform: 'none' }}
            >
              Continuar para falar com o atendente
            </Button>
          </Grid>
        )}

        {goBack && (
          <Stack gap={2} mt={3} alignItems={'center'}>
            <Button startIcon={<ChevronLeftIcon />} onClick={goBack} sx={{ fontWeight: 'bold' }}>
              Voltar
            </Button>
          </Stack>
        )}
      </Grid>
    </Page>
  );
};
